export default __webpack_public_path__ + "assets/Phone.69ad.svg";